// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vdekQX84hqgdB53tjtPZ{cursor:pointer;-webkit-user-select:none;user-select:none;justify-content:space-between;align-self:stretch;align-items:center;gap:8px;padding:16px;display:flex}.cDScVxZ30qkMP7D09NtN{align-items:center;column-gap:9px;min-width:0;display:flex}.cDScVxZ30qkMP7D09NtN.j_lxZs06Aw2m52i0Er0R{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `vdekQX84hqgdB53tjtPZ`,
	"box": `cDScVxZ30qkMP7D09NtN`,
	"fullWidth": `j_lxZs06Aw2m52i0Er0R`
};
export default ___CSS_LOADER_EXPORT___;
